import { Injectable } from '@angular/core';
import { SeuLocalStorageKey, SeuSessionStorageKey } from '@seu-types';
import { isNil } from 'lodash-es';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  constructor() {}

  public getItem<T = string>(
    key: SeuLocalStorageKey,
    keyPrefix?: string
  ): T | null {
    const storageKey = keyPrefix ? `${keyPrefix}-${key}` : key;
    const item = localStorage.getItem(storageKey);
    if (item) {
      return JSON.parse(item) as T;
    }
    return null;
  }

  public setItem<T>(
    key: SeuLocalStorageKey,
    value: T,
    keyPrefix?: string
  ): void {
    const storageKey = keyPrefix ? `${keyPrefix}-${key}` : key;
    if (isNil(value)) {
      localStorage.removeItem(storageKey);
    } else {
      localStorage.setItem(storageKey, JSON.stringify(value));
    }
  }

  public removeItem(key: SeuLocalStorageKey, keyPrefix?: string): void {
    const storageKey = keyPrefix ? `${keyPrefix}-${key}` : key;
    localStorage.removeItem(storageKey);
  }

  public getSessionItem<T = string>(
    key: SeuSessionStorageKey,
    keyPrefix?: string
  ): T | null {
    const storageKey = keyPrefix ? `${keyPrefix}-${key}` : key;
    const item = sessionStorage.getItem(storageKey);
    if (item) {
      return JSON.parse(item) as T;
    }
    return null;
  }

  public setSessionItem<T>(
    key: SeuSessionStorageKey,
    value: T,
    keyPrefix?: string
  ): void {
    const storageKey = keyPrefix ? `${keyPrefix}-${key}` : key;
    if (isNil(value)) {
      sessionStorage.removeItem(storageKey);
    } else {
      sessionStorage.setItem(storageKey, JSON.stringify(value));
    }
  }
}
